<template>
  <section class="data-table-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <v-data-table
      :headers="activity.logged_answers.headers.filter(v => v.value)"
      :items="activity.logged_answers.items"
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:body="{ items }">
        <tr v-for="(item, index) in items" :key="`row_${index}`">
          <td class="text-center">{{ item.step }}</td>
          <td
            class="text-left"
            v-for="(col, index) in columns"
            :key="'text_' + index"
          >
            {{ item[col.value] }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </section>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    columns() {
      return this.activity.logged_answers.headers.slice(1, -1)
    }
  }
}
</script>

<style lang="scss">
.data-table-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }
}
</style>
